export const SELECT_MENU_ITEMS = 'SELECT_MENU_ITEMS';
export const SELECT_MENU_ITEM = 'SELECT_MENU_ITEM';
export const CLEAR_SELECTION = 'CLEAR_SELECTION';
export const UNSELECT_MENU_ITEM = 'UNSELECT_MENU_ITEM';
export const UNSELECT_MENU_ITEMS = 'UNSELECT_MENU_ITEMS';

export const GET_RECIPE_FILTER_OPTIONS = 'GET_RECIPE_FILTER_OPTIONS';
export const SET_RECIPE_CATEGORIES = 'SET_RECIPE_CATEGORIES';
export const SET_RECIPE_SOURCES = 'SET_RECIPE_SOURCES';
export const SET_RECIPE_GROUPS = 'SET_RECIPE_GROUPS';
export const SET_RECIPE_HACCP = 'SET_RECIPE_HACCP';
export const SET_MEAL_TYPES = 'SET_MEAL_TYPES';
export const SET_RECIPE_SERVING_TEMP = 'SET_RECIPE_SERVING_TEMP';
export const GET_RECIPE_FILTER_OPTIONS_ERROR =
  'GET_RECIPE_FILTER_OPTIONS_ERROR';

export const SET_HACCPS = 'SET_HACCPS';
export const SET_HACCP_TYPES = 'SET_HACCP_TYPES';
export const SET_RECIPE_INSTRUCTION_DESCRIPTIONS =
  'SET_RECIPE_INSTRUCTION_DESCRIPTIONS';
export const EDIT_MENU_COPY = 'EDIT_MENU_COPY';
export const SET_ERROR = 'SET_ERROR';
export const EDIT_MENU_RESET_COPIED = 'EDIT_MENU_RESET_COPIED';



// WEBPACK FOOTER //
// ./src/pages/managemenu/state/common/types.js